module.exports = __webpack_public_path__ + "img/12.e67c3e2a.jpg";